import { motion } from 'framer-motion'
import { AlertCircle } from 'lucide-react'

interface Props {
  message: string
}

export default function AgentErrorLine({ message }: Props) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.15 }}
      className="flex items-center gap-2 py-1 pl-1"
    >
      <AlertCircle className="w-3.5 h-3.5 text-red-400 shrink-0" />
      <span className="font-mono text-sm text-red-400/80">{message}</span>
    </motion.div>
  )
}
